import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from "rxjs";

import { InitializeOnBehalfSpec } from "../../on-behalf/models/on-behalf.model";
import { FlowInstance } from "../models/flow.model";
import { FlowIndex, EjectLetterContent, PageView } from "../../common/models/flow.dto";


@Injectable({
    providedIn: 'root'
})
export class FlowOnBehalfService {

    private readonly BASE_URL: string = "/api/flow-on-behalf";

    constructor(private client: HttpClient) { }    

    generateIdentifierForTemplate(templateId: string): Observable<string> {
        return this.client.get<string>(`${this.BASE_URL}/generate-identifier/${templateId}`);
    }

    getClarificationNotes(instanceId: string): Observable<PageView[]> {
        return this.client.get<PageView[]>(`${this.BASE_URL}/get-clarification-notes/${instanceId}`);
    }

    getOnBehalfFlows(specName: string): Observable<FlowIndex[]> {
        return this.client.get<FlowIndex[]>(`${this.BASE_URL}/get-flows/${specName}`);
    }

    initializeFlow(spec: InitializeOnBehalfSpec): Observable<FlowInstance> {
        return this.client.post<FlowInstance>(`${this.BASE_URL}/initialize`, spec);
    }

    generateLetter(instanceId: string, templateId: string): Observable<string> {
        return this.client.get<string>(`${this.BASE_URL}/generateLetter/${instanceId}/${templateId}`);
    }

    generatePDF(content: EjectLetterContent): Observable<any> {
        const opt = {
            headers: new HttpHeaders({ "Content-Type": "application/json", "Accept": "application/pdf" }),
            responseType: 'blob' as 'blob'
        };
        return this.client.post(`${this.BASE_URL}/generatePDF`, content, opt);
    }

    queueLetter(content: EjectLetterContent): Observable<any> {
        return this.client.post(`${this.BASE_URL}/queueLetter`, content);
    }
}
